// extracted by mini-css-extract-plugin
module.exports = {"root":"m3QxQ","burger-content":"_1-CIB","burgerContent":"_1-CIB"};